/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Support_Sent_Description_TicketInputs */



/**
* | output |
* | --- |
* | "Thanks, we have your message. Your case number is #{number} - we will reply by email." |
*
* @param {Support_Sent_Description_TicketInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_sent_description_ticket = /** @type {((inputs: Support_Sent_Description_TicketInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Sent_Description_TicketInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Danke, deine Nachricht ist bei uns. Deine Fallnummer ist #${i?.number} - wir antworten dir per E-Mail.`)
	return /** @type {LocalizedString} */ (`Thanks, we have your message. Your case number is #${i?.number} - we will reply by email.`)
});